import scrollama from 'scrollama';

document.addEventListener('DOMContentLoaded', function () {
  const scroller = scrollama();

  let stickyBar = document.querySelector('[data-sticky-contact-detail]');
  let stickyBarTrigger = document.querySelector('[data-step]');

  if (stickyBar && stickyBarTrigger) {
    scroller
      .setup({
        step: stickyBarTrigger,
        offset: 0.2,
      })
      .onStepEnter(function () {
        stickyBar.classList.add('open');
      })
      .onStepExit(function () {
        stickyBar.classList.remove('open');
      });

    window.addEventListener('resize', scroller.resize);
  }
});
